"use strict";

require("core-js/modules/es.array.reduce.js");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _optionBuilder = _interopRequireDefault(require("./optionBuilder"));

var _types = _interopRequireDefault(require("../metadata/types"));

var _runtimeWrapper = _interopRequireDefault(require("../runtimeWrapper"));

var _error = require("../../error");

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function commandBuilder(name, context) {
  var environment = context.environment,
      commandRegistry = context.commandRegistry,
      pid = context.pid;
  var options = [];
  var args = [];
  return {
    name: name,
    addOption: function addOption(key) {
      var option = (0, _optionBuilder.default)(key, context);
      options.push(option);
      return option;
    },
    addArgument: function addArgument(argument) {
      args.push(argument);
      return this;
    },
    addVariable: function addVariable(key) {
      return this.addArgument(function (_, buildOpts) {
        return environment.get(key, {
          scope: buildOpts === null || buildOpts === void 0 ? void 0 : buildOpts.scope
        });
      });
    },
    getMetadata: function getMetadata() {
      return _defineProperty({}, _types.default.COMMAND, {
        name: name,
        options: options.map(function (option) {
          return option.getMetadata();
        }).reduce(function (acc, curr) {
          return _objectSpread({}, acc, {}, curr);
        }, {}),
        arguments: args.map(function (arg) {
          return arg.getMetadata ? arg.getMetadata() : (0, _lodash.isFunction)(arg) ? arg() : arg;
        })
      });
    },
    build: function build() {
      var buildOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var command = commandRegistry[name];

      if (!command) {
        throw new _error.CommandNotFoundError("Command not found: ".concat(name));
      }

      var wrapper = (0, _runtimeWrapper.default)(pid, command);
      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(incoming) {
          var opts,
              execArgs,
              interpolatedArgs,
              execOptionsP,
              execOptions,
              _args3 = arguments;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  opts = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                  execArgs = incoming ? [].concat(args, [incoming]) : args;
                  _context3.t0 = (0, _lodash.flatten);
                  _context3.next = 5;
                  return Promise.all(execArgs.map( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(arg) {
                      var value;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!(0, _lodash.isFunction)(arg)) {
                                _context.next = 5;
                                break;
                              }

                              _context.next = 3;
                              return arg(undefined, buildOpts);

                            case 3:
                              value = _context.sent;
                              return _context.abrupt("return", (0, _lodash.isArray)(value) ? (0, _lodash.flatten)(value) : value);

                            case 5:
                              return _context.abrupt("return", arg);

                            case 6:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x2) {
                      return _ref3.apply(this, arguments);
                    };
                  }()));

                case 5:
                  _context3.t1 = _context3.sent;
                  interpolatedArgs = (0, _context3.t0)(_context3.t1);
                  _context3.next = 9;
                  return Promise.all(options.map(function (opt) {
                    return opt.build(buildOpts);
                  }).map( /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
                      var _ref6, key, value;

                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _ref6 = _slicedToArray(_ref4, 2), key = _ref6[0], value = _ref6[1];

                              if (!(0, _lodash.isFunction)(value)) {
                                _context2.next = 9;
                                break;
                              }

                              _context2.t1 = key;
                              _context2.next = 5;
                              return value();

                            case 5:
                              _context2.t2 = _context2.sent;
                              _context2.t0 = [_context2.t1, _context2.t2];
                              _context2.next = 10;
                              break;

                            case 9:
                              _context2.t0 = [key, value];

                            case 10:
                              return _context2.abrupt("return", _context2.t0);

                            case 11:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    return function (_x3) {
                      return _ref5.apply(this, arguments);
                    };
                  }()));

                case 9:
                  execOptionsP = _context3.sent;
                  execOptions = execOptionsP.reduce(function (acc, _ref7) {
                    var _ref8 = _slicedToArray(_ref7, 2),
                        key = _ref8[0],
                        val = _ref8[1];

                    return _objectSpread({}, acc, _defineProperty({}, key, val));
                  }, {});
                  _context3.next = 13;
                  return wrapper.execute(interpolatedArgs, _objectSpread({}, opts, {}, execOptions));

                case 13:
                  return _context3.abrupt("return", _context3.sent);

                case 14:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }();
    }
  };
}

var _default = commandBuilder;
exports.default = _default;